export default __webpack_public_path__ + "static/airbnb-6-35e5014c5449f31e8af2b9ca9d90b6c8.png";